<template>
  <div class="account-info">
    <div class="user-info-container__title">
      Данные аккаунта
    </div>
    <el-row :gutter="20">
      <template v-for="item in fields">
        <el-col
          :sm="12"
          :xs="24"
          :key="item.code">
          <component
            :is="getComponentName(item.code)"
            :item="item"
            @onUpdate="onUpdate"/>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script>
  import AccountEmail from './AccountEmail'
  import AccountText from './AccountText'
  import AccountPhone from './AccountPhone'
  import {mapMutations} from 'vuex'

  export default {
    name: 'AccountInfo',
    components: {
      AccountEmail,
      AccountText,
      AccountPhone
    },
    data: function () {
      return {
        fields: [
          {
            code: 'email',
            value: '',
            name: 'Email',
            isValidate: false
          },
          {
            code: 'phone',
            value: '',
            name: 'Телефон',
            isValidate: false
          },
          {
            code: 'name',
            value: '',
            name: 'Имя',
            isValidate: false
          },
          {
            code: 'lastName',
            value: '',
            name: 'Фамилия',
            isValidate: false
          }
        ]
      }
    },
    methods: {
      ...mapMutations('order', [
        'setAccountInfoList'
      ]),
      getComponentName: function (code) {
        switch (code) {
          case 'email':
            return 'AccountEmail'
          case 'phone':
            return 'AccountPhone'
          default:
            return 'AccountText'
        }
      },
      onUpdate: function (item) {
        const fields = [...this.fields.map(e => {
          if (e.code === item.code) {
            return Object.assign({}, e, item)
          }
          return e
        })]

        this.fields = fields
        this.setAccountInfoList(fields)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/UserInfo/AccountInfo.vue